var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHereBigIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7489 8.58807C11.0837 8.26267 11.0837 7.73423 10.7489 7.40884L6.46418 3.2438C6.12944 2.91841 5.58581 2.91841 5.25106 3.2438C4.91631 3.56919 4.91631 4.09764 5.25106 4.42303L8.9306 7.99976L5.25374 11.5765C4.91899 11.9019 4.91899 12.4303 5.25374 12.7557C5.58848 13.0811 6.13211 13.0811 6.46686 12.7557L10.7516 8.59067L10.7489 8.58807Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHereBigIco16);
export default __webpack_public_path__ + "static/media/Here_big_ico_16.9d4600c3c730d99d05d79c700c57c430.svg";
export { ForwardRef as ReactComponent };